import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { FormControlComponent } from './form-control/form-control.component';
import { FormLabelComponent } from './form-label/form-label.component';
import { InputComponent } from './input/input.component';
import { InputIconComponent } from './input-icon/input-icon.component';
import { SelectComponent } from './select/select.component';
import { SelectScrollableComponent } from './select-scrollable/select-scrollable.component';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { TextareaComponent } from './textarea/textarea.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { SpinnerModule } from '@lib/ui/spinner';
import { IconsModule } from '@lib/icons';
import { RadioComponent } from './radio/radio/radio.component';
import { RadioGroupComponent } from './radio/radio-group/radio-group.component';

@NgModule({
  declarations: [
    CheckboxComponent,
    RadioGroupComponent,
    RadioComponent,
    FormControlComponent,
    FormLabelComponent,
    InputComponent,
    InputIconComponent,
    SelectComponent,
    SelectScrollableComponent,
    TextareaComponent,
    SearchInputComponent,
  ],
  exports: [
    CheckboxComponent,
    RadioGroupComponent,
    RadioComponent,
    FormControlComponent,
    FormLabelComponent,
    InputComponent,
    SelectComponent,
    SelectScrollableComponent,
    ReactiveFormsModule,
    FormsModule,
    TextareaComponent,
    SearchInputComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxTrimDirectiveModule,
    NgxMaskModule.forRoot(),
    SpinnerModule,
    IconsModule,
  ],
})
export class FormElementsModule {}
